import { hashHistory } from 'react-router';
import store from '../store';
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {switchToWizardItem} from "../bvcomponents/qkbPages/materialsWizard/useChangeWizardStepRoute";

export const changeRoutePath = (activePart, nextRelatedItemIndex, withHidden = true) => {
  let selectionGroup = store.getState().selectionState.selectionGroup;
  if (!selectionGroup) {
    return
  }
  const partName = selectionGroup.toLowerCase();
  // console.log('activePart', activePart);
  if (!activePart) {
    return
  }
  if (activePart.menuType === 0 || activePart.partName === "Toilet") {
    const nextPath = 'materials/'+partName;
    if (!window.location.href.includes(nextPath)) {
      hashHistory.push(nextPath);
    }
  } else {
    const part = activePart.subParts(withHidden)[nextRelatedItemIndex];
    if (part) {
      const subPartName = part.part.partName.toLowerCase().replace(" ","-");
      const nextPath = 'materials/'+partName+'/'+subPartName;
      if (!window.location.href.includes(nextPath)) {
        hashHistory.push(nextPath);
      }
    }
  }
};

export const getMaterialsFixedName = (qtCategoryName = "") => {
  return qtCategoryName.replace(/ /g,"-").replace(/\//g,"-").toLowerCase()
}

export const changeQTRoutePath = (qtCategoryName, nextRelatedItemIndex) => {

  const {wizardIsActive, wizardActiveItem} = store.getState().wizardState;
  if (wizardIsActive) {
    switchToWizardItem(wizardActiveItem);
    return
  }

  const layout = getCurrentLayout();
  if (!qtCategoryName) {
    qtCategoryName = store.getState().qtState.qtActiveCategory || layout.qtCategories[0].name;
  }
  if (!nextRelatedItemIndex && (nextRelatedItemIndex !== 0)) {
    nextRelatedItemIndex = store.getState().selectionState.activePartRelatedItemIndex;
  }
  let qtCategory = layout.qtCategories.find(qtCat => qtCat.name === qtCategoryName);
  if (!qtCategory) { //cases when we switched visualizer type and qtCategoryName is still an old one
    qtCategory = layout.qtCategories[0];
  }
  let partName = getMaterialsFixedName(qtCategoryName);
  let nextSubPart = qtCategory.subParts[nextRelatedItemIndex] || qtCategory.subParts[0];
  if (!nextSubPart) {
    console.log("ERROR, no subparts exist in the category", qtCategory);
    if (layout.qtCategories[0] && layout.qtCategories[0].subParts.length) {
      hashHistory.push('materials/'+partName);
      return
    } else {
      for (let i = 0; i < layout.qtCategories.length; i++) {
        // here we check at least some category which has featureGroup with features!
        if (layout.qtCategories[i] && layout.qtCategories[i].subParts.length) {
          partName = getMaterialsFixedName(layout.qtCategories[i].name);
          nextSubPart = layout.qtCategories[i].subParts[0];
          break;
        }
      }
    }
  }
  if (!nextSubPart) {
    hashHistory.push("/materials");
    return;
  }
  const subPartName = getMaterialsFixedName(nextSubPart.part.partName);
  const nextPath = 'materials/'+partName+'/'+subPartName;
  if (!window.location.href.includes(nextPath)) {
    hashHistory.push(nextPath);
  }

  return nextSubPart

};
